export const userConstants = {
    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',
    WAITING_APPROVE_ACCOUNT: 'USERS_WAITING_APPROVE_ACCOUNT',
    GET_MEMBER_REQUEST: 'GET_MEMBER_REQUEST',
    GET_MEMBER_ACCOUNT: 'GET_MEMBER_ACCOUNT',
    GET_MEMBER_ACCOUNT_FAILED: 'GET_MEMBER_ACCOUNT_FAILED',
    SHOW_RESET_PASSWORD: 'SHOW_RESET_PASSWORD',
    LOGOUT: 'USERS_LOGOUT',
    IS_LOADING: 'IS_LOADING',
    HIDE_HOMEPAGE_ANNOUNCEMENT: 'HIDE_HOMEPAGE_ANNOUNCEMENT',
    HIDE_DEPOSIT_ANNOUNCEMENT: 'HIDE_DEPOSIT_ANNOUNCEMENT',
    HIDE_WITHDRAW_ANNOUNCEMENT: 'HIDE_WITHDRAW_ANNOUNCEMENT',
    GET_UNREAD_MSG: 'GET_UNREAD_MSG',
    ADD_CRYPTO_CHANNEL: 'ADD_CRYPTO_CHANNEL',
    UPDATE_CLAIM_COUNT: 'UPDATE_CLAIM_COUNT',
    UPDATE_CLAIM_COUNT_BY_CATEGORY: 'UPDATE_CLAIM_COUNT_BY_CATEGORY',
    UPDATE_USER_VERIFICATION: 'UPDATE_USER_VERIFICATION',
    UPDATE_IS_BALANCE_MASKED: 'UPDATE_IS_BALANCE_MASKED',
    GET_AFFILIATE_OR_REFERRAL_CODE: 'GET_AFFILIATE_OR_REFERRAL_CODE',
    UPDATE_AFF_WALLET: 'UPDATE_AFF_WALLET',
    UPDATE_AFF_CREDIT: 'UPDATE_AFF_CREDIT',
    UPDATE_AUTH_SETTINGS: 'UPDATE_AUTH_SETTINGS',
    GET_REFERRAL_MY_ACCOUNT_TYPE_ENABLED: 'GET_REFERRAL_MY_ACCOUNT_TYPE_ENABLED',
    GET_MEMBER_MSG_TYPE: 'GET_MEMBER_MSG_TYPE',
    CHECK_WITHDRAW_PIN: 'CHECK_WITHDRAW_PIN',
    SET_DEPOSIT_STATUS: 'SET_DEPOSIT_STATUS',
    AFFILIATE_SETTINGS: 'AFFILIATE_SETTINGS',
    CHECK_SIX_DIGIT_PIN: 'CHECK_SIX_DIGIT_PIN',
    USER_TOKEN: 'USER_TOKEN',
    MEMBER_SUMSUB_KYC_INFO: 'MEMBER_SUMSUB_KYC_INFO',
};

export const USER_LOGIN_ERROR_CODE = {
    TURNSTILE_ATTEMPT_REACH: 6206,
};
